<template>
  <div class="form">
    <slot></slot>
  </div>
</template>

<script>
import AsyncValidator from "async-validator";

export default {
  name: "v-form",
  props: {
    model: {
      type: Object
    },
    rule: {
      type: Object
    }
  },
  data() {
    return {
      formItems: []
    };
  },
  mounted() {
    this.calcFormItems();
  },
  updated() {
    this.calcFormItems();
  },
  methods: {
    calcFormItems() {
      // 获取form-item的引用
      if (this.$slots.default) {
        // 原始版
        // let children = this.$slots.default.filter(vnode => {
        //   return (
        //     vnode.tag &&
        //     vnode.componentOptions &&
        //     vnode.componentOptions.Ctor.options.name === "form-item"
        //   );
        // }).map(({ componentInstance }) => componentInstance);
        // 修改版 
        let children = [];
        this.$slots.default.forEach(vnode => {
          if (vnode.tag) {
            if (vnode.componentOptions && vnode.componentOptions.Ctor.options.name === "form-item") {
              children.push(vnode);
            } else if (vnode.children.length) {
              let ret = this.findFormItem(vnode.children);
              if (ret.length) children.push(...ret);
            } else {
              // console.warn(vnode);
            }
          } else {
            // console.warn(vnode);
          }
        });
        children = children.map(({ componentInstance }) => componentInstance);

        if (
          !(
            children.length === this.formItems.length &&
            children.every((pane, index) => pane === this.formItems[index])
          )
        ) {
          this.formItems = children;
          // 校验
          // const toCheck = () => {
          //   console.info('Checking...');
          // }
          // this.formItems.forEach(formItem => {
          //   let itemVNode = formItem.$slots.default[0];
          //   let itemRules = this.rule[formItem.prop];
          //   if (itemRules && ['input', 'select'].indexOf(itemVNode.tag) != -1) {
          //     itemRules.forEach(rule => {
          //       if (rule.trigger in itemVNode.elm) {
          //         itemVNode.elm.addEventListener(rule.trigger, toCheck, false);
          //       }
          //     })
          //   }
          // });
        }
      }
    },
    findFormItem(target) {
      let ret = []
      if (Array.isArray(target) && target.length) {
        target.forEach(vnode => {
          if (vnode.tag && vnode.componentOptions && vnode.componentOptions.Ctor.options.name === "form-item") {
            ret.push(vnode);
          } else if (Array.isArray(vnode.children) && vnode.children.length) {
            ret = ret.concat(this.findFormItem(vnode.children));
          } else {
            // console.warn(vnode);
          }
        });
      } else if (Array.isArray(target.children) && target.children.length) {
        ret = ret.concat(this.findFormItem(target.children));
      }
      return ret;
    },
    validate() {
      let validator = new AsyncValidator(this.rule);

      let isSuccess = true;

      let findErrorByProp = (errors, prop) => {
        return (
          errors.find(error => {
            return error.field === prop;
          }) || ""
        );
      };

      validator.validate(this.model, errors => {
        this.formItems.forEach(formItem => {
          let prop = formItem.prop;
          let error = findErrorByProp(errors || [], prop);
          if (error) {
            isSuccess = false;
          }

          formItem.showError((error && error.message) || "");
        });
      });

      return Promise.resolve(isSuccess);
    },
    resetFields() {
      this.formItems.forEach(formItem => {
        formItem.showError("");
      });
    }
  }
};
</script>
